import React, { useEffect, useState, useCallback } from "react";
import { Link } from "react-router-dom";
import { Heart, ArrowRight } from "lucide-react";
import { PlatformLayout } from "./PlatformLayout";
import { ListingCard } from "./ListingCard";
import { Reveal } from "./Reveal";
import { AnimatedTitle } from "./AnimatedTitle";
import { fetchListings } from "./api";
import { getFavorites } from "./analytics";

export default function Favoris() {
  const [all, setAll] = useState([]);
  const [favSlugs, setFavSlugs] = useState(getFavorites());
  const [loading, setLoading] = useState(true);

  useEffect(() => { fetchListings({}).then((d) => { setAll(d); setLoading(false); }); }, []);

  const refresh = useCallback(() => setFavSlugs(getFavorites()), []);
  useEffect(() => {
    window.addEventListener("omk-favorites-changed", refresh);
    return () => window.removeEventListener("omk-favorites-changed", refresh);
  }, [refresh]);

  const items = all.filter((l) => favSlugs.includes(l.slug));

  return (
    <PlatformLayout searchDock={false} solidHeader>
      <div className="pt-28 sm:pt-32 pb-24 max-w-[1500px] mx-auto px-6 lg:px-12" data-testid="favoris-page">
        <Reveal className="mb-8">
          <span className="calli text-lg text-[#C19A6B]">Votre sélection</span>
          <AnimatedTitle as="h1" className="text-3xl sm:text-4xl font-light tracking-tight mt-1" text="Mes biens favoris" />
        </Reveal>

        {loading ? (
          <p className="text-zinc-500 py-16 text-center">Chargement…</p>
        ) : items.length === 0 ? (
          <div className="py-24 text-center" data-testid="favoris-empty">
            <Heart className="w-10 h-10 text-zinc-600 mx-auto mb-4" />
            <p className="text-zinc-400">Vous n'avez pas encore de bien favori.</p>
            <Link to="/biens-off-market" className="inline-flex items-center gap-2 mt-5 text-sm text-[#C19A6B] hover:gap-3 transition-all">Parcourir les biens <ArrowRight className="w-4 h-4" /></Link>
          </div>
        ) : (
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="favoris-grid">
            {items.map((l, i) => <ListingCard key={l.slug} listing={l} index={i} />)}
          </div>
        )}
      </div>
    </PlatformLayout>
  );
}
